import { useFirestoreCollection } from "@p0security/frontend-core/react";
import { selfHostedComputersPath } from "@p0security/integrations-self-hosted-shared/constants";
import type { SelfHostedComputer } from "@p0security/integrations-self-hosted-shared/types";
import { where } from "firebase/firestore";

export const useSelfHostedComputers = ({
  tenantId,
  environmentId,
}: {
  tenantId: string;
  environmentId: string;
}) => {
  return useFirestoreCollection<SelfHostedComputer>(
    selfHostedComputersPath(tenantId),
    {
      live: true,
      queryConstraints: [where("environmentId", "==", environmentId)],
    }
  );
};
